import {useState} from "react";
import {Box, Typography, useTheme} from "@mui/material";
import ListView from "../ListView/ListView";
import useApiRequest from "../../hooks/useApiRequest";
import ScopeRolesFilterBar from "./ScopeRolesFilterBar";

const normalizeArray = (value) => {
  if (Array.isArray(value?.data)) return value.data;
  if (Array.isArray(value?.items)) return value.items;
  if (Array.isArray(value?.results)) return value.results;
  if (Array.isArray(value)) return value;
  return [];
};

const ScopeRolesList = ({scopeId}) => {
  const theme = useTheme();
  const [roles, setRoles] = useState([]);

  const {loading, makeRequest} = useApiRequest({baseUrl: "/scopes", resource: "scopes"});

  const handleSearch = async (params) => {
    const result = await makeRequest("get", `/${scopeId}/roles`, null, {params});
    if (result?.success) {
      setRoles(normalizeArray(result.data));
    }
    return [];
  };

  const columns = [
    {
      field: "name",
      headerName: "Nombre",
      editable: false
    },
    {
      field: "product_name",
      headerName: "Producto",
      editable: false
    },
    {
      field: "description",
      headerName: "Descripción",
      editable: false
    }
  ];

  if (!scopeId) {
    return (
      <Box sx={{padding: 2}}>
        <Typography variant="body2" color={theme.palette.text.secondary}>
          No hay scope seleccionado
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{width: "100%", marginTop: 3}}>
      <Typography variant="h6" gutterBottom sx={{fontWeight: "bold", color: theme.palette.text.primary}}>
        Roles Asociados
      </Typography>

      <ScopeRolesFilterBar scopeId={scopeId} onSearch={handleSearch} />

      <ListView columns={columns} data={roles} loading={loading} getRowId={(row) => row.role_id} />
    </Box>
  );
};

export default ScopeRolesList;
